export const LOADING_MESSAGE = '请稍等...';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const GET_QA_QUESTION_SUCCESS = 'GET_QA_QUESTION_SUCCESS';
export const UPDATE_COMMENT_COUNTDOWN = 'UPDATE_COMMENT_COUNTDOWN';
export const UPDATE_QA_QUESTION = 'UPDATE_QA_QUESTION';
export const UPDATE_QA_ANSWER = 'UPDATE_QA_ANSWER';
export const PUSH_QA_TEACHER_ANSWER = 'PUSH_QA_TEACHER_ANSWER';
export const PUSH_QA_ANSWER = 'PUSH_QA_ANSWER';
export const FOLLOW_QA_QUESTION_SUCCESS = 'FOLLOW_QA_QUESTION_SUCCESS';
export const FEEDBACK_QA_QUESTION_SUCCESS = 'FEEDBACK_QA_QUESTION_SUCCESS';
export const THUMB_QA_QUESTION_SUCCESS = 'THUMB_QA_QUESTION_SUCCESS';
export const COMMENT_QA_QUESTION_SUCCESS = 'COMMENT_QA_QUESTION_SUCCESS';
export const GET_QUESTION_REFERRAL_LIST_IN_QUESTION_SUCCESS =
  'GET_QUESTION_REFERRAL_LIST_IN_QUESTION_SUCCESS';
export const GET_QUESTION_SHARED_NOTE_IN_QUESTION_SUCCESS =
  'GET_QUESTION_SHARED_NOTE_IN_QUESTION_SUCCESS';
